import { render, staticRenderFns } from "./WFCaseQueryConfigView.vue?vue&type=template&id=90b17546&scoped=true"
import script from "./WFCaseQueryConfigView.vue?vue&type=script&lang=js"
export * from "./WFCaseQueryConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b17546",
  null
  
)

export default component.exports